<div class="testimonial-container">
    <div class="testimonial">{{testimonial}}</div>
    <div class="name">{{name}}</div>
    <div class="company">{{company}}</div>
</div>
